import { defineMessages } from 'react-intl';
import globalIntl from 'globalIntl'; // eslint-disable-line import/no-unresolved

const m = defineMessages({
  enterKeyName1: {
    id: 'enterKeyName1',
    defaultMessage: 'Name',
  },
  enterKeyName2: {
    id: 'enterKeyName2',
    defaultMessage: '(Enter a unique name for your credential)',
  },
  enterKeyNamePlaceholder: {
    id: 'enterKeyNamePlaceholder',
    defaultMessage: 'Example: API robot v.2',
  },
  scopes1: {
    id: 'scopes1',
    defaultMessage: 'Scopes',
  },
  scopes2: {
    id: 'scopes2',
    defaultMessage: '(Choose 1 or more scopes for new credential)',
  },
  webhookUrl: {
    id: 'webhookUrl',
    defaultMessage: 'Webhook URL',
  },
  webhookInfo: {
    id: 'webhookInfo',
    defaultMessage: '(Enter webhook url where credential events will come)',
  },
  webhookPlaceholder: {
    id: 'webhookPlaceholder',
    defaultMessage: 'Example: https://example.com/api',
  },
  uploadImage: {
    id: 'uploadImage',
    defaultMessage: 'Upload image',
  },
});

export default { ...globalIntl, ...m };
